import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of} from 'rxjs';
import { environment } from '../../environments/environment';
import { RoundInfoResponse } from '../model/round-info-response.model';
import { roundInfoFakeData } from '../../assets/commonAssets/fakeData.js';

@Injectable({
  providedIn: 'root'
})
export class TrackingParcelRoutingService {

  constructor(private http: HttpClient) {
  }

  getRoundInfo(parcelUuid: string): Observable<RoundInfoResponse> {
    if (environment.fakeData) {
      return of(roundInfoFakeData);
    }
    return this.http.get<RoundInfoResponse>('tpr/getRoundInfo?uuid=' + parcelUuid);
  }

  getCdiscountAccounts(): Observable<any> {
    if (environment.fakeData) {
      return of(["999999", "000000"]);
    }
    return this.http.get('tpr/getCdiscountAccounts', {responseType: 'text'});
  }
  
  getApiKeyTrackEngage(): Observable<any> {
    if (environment.fakeData) {
      return of("ENA_VN1blsabt37zS5CztL4dq_0G98zjqNknmyvr32o");
    }
    return this.http.get('tpr/getApiKeyTrackEngage', {responseType: 'text'});
  }

}
